/* KOUCHTA — Luxury Interactions V6 */
// Add js-enabled class immediately so CSS knows JS is available
document.documentElement.classList.add('js-enabled');
document.body ? document.body.classList.add('js-enabled') : document.addEventListener('DOMContentLoaded', () => document.body.classList.add('js-enabled'));

document.addEventListener('DOMContentLoaded', () => {
  // Scroll reveal
  const reveals = document.querySelectorAll('.k-reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.dataset.delay || 0;
        setTimeout(() => entry.target.classList.add('k-visible'), delay * 150);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
  reveals.forEach(el => observer.observe(el));

  // Parallax for heritage bg
  const heritageBg = document.querySelector('.kouchta-heritage__bg');
  if (heritageBg) {
    window.addEventListener('scroll', () => {
      const scrolled = window.pageYOffset;
      const offset = scrolled * 0.3;
      heritageBg.style.transform = `translateY(${offset}px)`;
    }, { passive: true });
  }

  // Smooth scroll for nav links
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
